var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { GoalPlannerTemplate } from '@/models/GoalPlannerTemplate';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { RpcClient } from '@/http';
import { Group } from '@/models/Group';
import AWeekPicker from '@/components/AWeekPicker/AWeekPicker.vue';
import i18n from '@/i18n';
let AddTemplateDialog = class AddTemplateDialog extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.templates = [];
        this.selectedTemplate = null;
        this.startsAtDates = [];
        this.startsAtDate = '';
        this.belongsToUserFilterItems = [
            {
                label: this.$tc('All templates'),
                value: 0,
            },
            {
                label: this.$tc('My templates only'),
                value: 1,
            },
        ];
        this.filters = {
            belongs_to_user: 1,
        };
        this.templatesIterationKey = 0;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchTemplates();
        await this.initializeDates();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onWeeksSelected(weeks) {
        if (weeks.length === 0) {
            this.startsAtDates = [];
            return;
        }
        this.startsAtDates = weeks.map((w) => w.startsAt);
    }
    async onSubmit() {
        if (!this.selectedTemplate)
            return;
        try {
            await new RpcClient().execute('add-template-to-group', {
                group_id: this.group.id,
                template_id: this.selectedTemplate.id,
                starts_at: this.type === 'week' ? this.startsAtDates : [this.startsAtDate],
            });
            this.$emit('template:added');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Class methods
    getAllowedDates(date) {
        const day = new Date(date).getDay();
        return day !== 0 && day !== 6; // Exclude Sunday (0) and Saturday (6)
    }
    close() {
        this.$emit('close');
        this.clear();
    }
    clear() {
        this.selectedTemplate = null;
        this.startsAtDates = [];
        this.startsAtDate = '';
    }
    async initializeDates() {
        await new Promise((resolve) => setTimeout(resolve, 50));
        this.startsAtDate = this.activeStart;
        this.startsAtDates = [this.activeStart];
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchTemplates() {
        try {
            this.templates = await new GoalPlannerTemplate()
                .filter({ type: this.type, belongs_to_user: this.filters.belongs_to_user })
                .limit(100)
                .all();
            this.templatesIterationKey += 1;
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get title() {
        return this.type === 'week' ? this.$tc('Add week template') : this.$tc('Add day template');
    }
    get currentLocale() {
        if (!i18n || !i18n.locale) {
            return 'nl';
        }
        return i18n.locale;
    }
    // #endregion
    // #region @Watchers
    onFiltersChanged() {
        this.fetchTemplates();
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], AddTemplateDialog.prototype, "group", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], AddTemplateDialog.prototype, "type", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], AddTemplateDialog.prototype, "activeStart", void 0);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddTemplateDialog.prototype, "onFiltersChanged", null);
AddTemplateDialog = __decorate([
    Component({
        components: {
            AWeekPicker,
        },
    })
], AddTemplateDialog);
export default AddTemplateDialog;
// #endregion
// #region Constants
// #endregion
